import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { CalendarX, Check, X } from "lucide-react";
import { formatRange } from "@/lib/constants";

export function UnavRequestsPanel({ onChanged }) {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/unavailability/requests").then((r) => { setItems(r.data); setSel((s) => s.filter((id) => r.data.some((u) => u.id === id))); }).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  if (!items.length) return null;
  const decide = async (ids, approve) => {
    setBusy(true);
    try {
      const r = await api.post("/unavailability/requests/decide", { ids, approve });
      toast.success(`${r.data.done} indisponibilit${r.data.done === 1 ? "à" : "à"} ${approve ? "approvat" : "rifiutat"}${r.data.done === 1 ? "a" : "e"}`);
      setSel([]); load(); onChanged?.();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  return (
    <section data-testid="unav-requests-panel" className="rounded-xl border border-orange-500/40 bg-orange-500/5 p-3 sm:p-4 space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <CalendarX className="w-4 h-4 text-orange-400" />
        <h3 className="font-semibold text-orange-200 flex-1">Indisponibilità da approvare ({items.length})</h3>
        <Button size="sm" disabled={busy || !sel.length} data-testid="unav-approve-selected" onClick={() => decide(sel, true)} className="bg-emerald-500 hover:bg-emerald-600 text-slate-950 font-semibold"><Check className="w-4 h-4 mr-1" />Approva selezionate ({sel.length})</Button>
        <Button size="sm" variant="outline" disabled={busy || !sel.length} data-testid="unav-reject-selected" onClick={() => decide(sel, false)} className="border-red-500/50 text-red-300 hover:bg-red-500/10"><X className="w-4 h-4 mr-1" />Rifiuta</Button>
        <Button size="sm" disabled={busy} data-testid="unav-approve-all" onClick={() => decide(items.map((u) => u.id), true)} className="bg-emerald-600/80 hover:bg-emerald-600 text-white font-semibold">Approva tutte</Button>
      </div>
      <div className="grid gap-1.5 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((u) => (
          <label key={u.id} data-testid={`unav-req-${u.id}`} className="flex items-center gap-2 rounded-lg border border-slate-800 bg-slate-900/60 px-3 py-2 text-sm cursor-pointer hover:border-orange-500/40 transition-colors">
            <Checkbox checked={sel.includes(u.id)} onCheckedChange={() => toggle(u.id)} data-testid={`unav-req-check-${u.id}`} />
            <span className="flex-1 min-w-0"><b className="text-slate-100">{u.tech_name}</b> <span className="text-red-300">{formatRange(u.start, u.end)}</span>{u.reason && <span className="block truncate text-xs text-slate-400">{u.reason}</span>}</span>
          </label>
        ))}
      </div>
    </section>
  );
}
